import activeFilter from './activefilter.filter';
import lessThanToText from './lessthantotext.filter';
import displayText from './displaytext.filter';
import getActiveOptionValue from './getactiveoptionvalue.filter';
import roundUp from './roundup.filter';

const moduleName = 'usc.core.filters';

angular.module(moduleName, [])
    .filter('activeFilter', activeFilter)
    .filter('lessThanToText', lessThanToText)
    .filter('displayText', displayText)
    .filter('getActiveOptionValue', getActiveOptionValue)
    .filter('roundUp', roundUp);

export default moduleName;